<template>
  <div class="parent-container">
    <div class="parent-toolbar">
      <WidgetToolbar title="Organization" :icon="require('@/assets/admin-icon/menu/school_active.svg')">
        <div class="options">
          <div class="row">
            <widgetSearch icon="right" v-model="search_member_input" @keyup="searchCompanyMember()"
              placeholder="Type in to Search…"></widgetSearch>

            <widgetDropdown v-if="false" v-model="show_filter" :right="true" :hover="false" :interactive="true">
              <button class="btn-dropdown">
                <img src="@/assets/admin-icon/filter.svg" class="icon" />
                Filter
                <img class="icon" src="@/assets/icon/carret-bottom-gray.svg" />
              </button>
              <div slot="dropdown" class="dropdown-widget right">
                <a class="dropdown-item" href="#" v-for="(item, index) in view_filter" :key="index" @click="() => {
                  selected_view_filter = item.value;
                }
                  ">
                  {{ item.name }}
                </a>
              </div>
            </widgetDropdown>

            <div class="v-line-divider" style="height: 40px"></div>
            <widgetButton :loading="false" class="btn-secondary" @click="addMember()">
              Add Consultant +
            </widgetButton>
          </div>
        </div>
      </WidgetToolbar>
    </div>
    <div class="company-profile-wrapper">

      <div class="company-profile-container">
        <multipane class="custom-resizer" layout="vertical">
          <div class="items">
            <div class="company-profile-body">
              <loading :height="20" color="#1ba5a4" :opacity="1" :width="20" :active.sync="user_loading"
                :is-full-page="false" :can-cancel="false" background-color="#fff" class="loader"></loading>
              <!-- For All Consultant -->
              <div class="list-container" v-if="user &&
                user.consultants &&
                user.consultants.length > 0
                ">
                <div class="table-label">All Consultants</div>
                <div class="table-container">
                  <table class="table-data">
                    <thead class="table-header">
                      <tr class="th-tr">
                        <th class="table-th-stick-top">Consultant name</th>
                        <th class="table-th-stick-top">Team</th>
                        <th class="table-th-stick-top">Contacts</th>
                        <th class="table-th-stick-top"></th>
                      </tr>
                    </thead>
                    <tbody class="table-body">
                      <template v-for="(item, index) in user.consultants">
                        <tr :key="index" :class="{ active: item.active }" class="row-data">
                          <td @click="viewItem(item)">
                            <widgetProfile :title="item.first_name + ' ' + item.last_name" :subtitle="item.profile ? item.profile.address : ''
                              " :file_name="item.profile_picture" :path="$fullUrl('images/profiles/')"></widgetProfile>
                          </td>

                          <td @click="viewItem(item)">
                            <div v-if="item.teams.length > 0" class="email-phone">
                              <span class="email crop-text">{{
                                item.teams[0].name | validate
                              }}</span>
                            </div>
                          </td>

                          <td @click="viewItem(item)">
                            <div class="email-phone">
                              <span class="email">{{
                                item.email | validate
                              }}</span>
                              <span class="phone" v-if="item.profile">{{
                                item.profile.phone | validate
                              }}</span>
                            </div>
                          </td>
                          <td>
                            <div class="menu">
                              <!-- Dropdown -->
                              <dropdown-menu>
                                <ul>
                                  <li>
                                    <a href @click.prevent="transferConsultant(item)">Change Team</a>
                                  </li>
                                  <li>
                                    <a href @click.prevent="updateConsultant(item)">Update Information</a>
                                  </li>
                                  <li>
                                    <a href @click.prevent="showinviteManagerModal(item.id)">Invite As Manager</a>
                                  </li>
                                  <li>
                                    <a href @click.prevent="manageConsultant(item.id)">Manage Profile</a>
                                  </li>
                                  <li>
                                    <app-dialog title="Remove Consultant"
                                      ask="Are you sure? This consultant will be removed from the scholl and will not be managed any further."
                                      yesText="Remove" noText="Cancel" @onComfirm="removeConsultant(item)">
                                      <a @click.prevent="">Remove consultant</a>
                                    </app-dialog>
                                  </li>
                                </ul>
                              </dropdown-menu>
                              <!-- End of dropdown -->
                            </div>
                          </td>
                        </tr>
                      </template>
                    </tbody>
                  </table>
                  <!-- loading on pagination -->
                  <div class="loading-paginated-items" v-if="false">
                    <loading :height="15" color="#1ba5a4" :opacity="1" :width="15"
                      :active.sync="isLoadingDataOnPagination" :is-full-page="false" :can-cancel="false"
                      background-color="#fff" class="loader"></loading>
                  </div>
                </div>
              </div>
              <!-- Empty consultant data widget -->
              <div class="empty-widget" v-if="user &&
                user.consultants &&
                user.consultants.length == 0
                ">
                <div class="empty-widget-body">
                  <p v-if="search_member_input">
                    Consultant you are trying to search not found,
                    <br />Click below to add one
                  </p>
                  <p v-else>
                    You have not yet added consultant,
                    <br />Click below to add one
                  </p>
                  <button class="add-btn" @click="addMember()">
                    Add a consultant
                  </button>
                </div>
              </div>
            </div>
          </div>
          <multipane-resizer></multipane-resizer>
          <div class="item-view-more" :style="{ flexGrow: 1 }" v-if="consultant_item">
            <div class="consultants-item">
              <div class="consultants-item-header">
                <widgetProfile :title="consultant_item.first_name + ' ' + consultant_item.last_name
                  " :subtitle="consultant_item.profile
    ? consultant_item.profile.address
    : ''
    " :file_name="consultant_item.profile_picture" :path="$fullUrl('images/profiles/')" :size="60" :text_size="22">
                </widgetProfile>

                <div class="consultants-item-header-options">
                  <button class="close-btn" @click="showConsultants()">
                    <span>&times;</span>
                  </button>
                </div>
              </div>
              <div class="consultants-item-body">
                <div class="consultants-info">
                  <h5 v-if="consultant_item.profile">Telephone</h5>
                  <p v-if="consultant_item.profile">
                    {{ consultant_item.profile.phone | validate }}
                  </p>
                  <h5 v-if="$validateData(consultant_item.email)">E-mail</h5>
                  <p>{{ consultant_item.email | validate }}</p>


                  <h5>Team</h5>
                  <p v-if="consultant_item.teams.length > 0">{{ consultant_item.teams[0].name | validate }}</p>
                  <p v-else>Not Set</p>

                  <h5 v-if="consultant_item.profile &&
                    consultant_item.profile.description
                    ">
                    Description
                  </h5>
                  <div v-if="consultant_item.profile" class="description" v-html="consultant_item.profile.description">
                  </div>
                  <h5>Skills</h5>
                  <div class="skills-widget">
                    <div class="skills_content__wrapper">
                      <div class="skill_box">
                        <div class="skill_box_header">
                          <label>Tools</label>
                        </div>
                        <div class="skill_box_body" v-if="consultant_item.skills.tools.length > 0">
                          <div class="row__item" v-for="(
                                                              value, i
                                                            ) in consultant_item.skills.tools.slice(0, 5)" :key="i">
                            <span>{{ value.name | validate }}</span>
                            <star-rating inactive-color="#C1C1C1" :read-only="true" active-color="#1BA5A4" :star-size="14"
                              :show-rating="false" v-model="value.level"></star-rating>
                          </div>
                        </div>
                        <div class="skill_box_body" v-else>
                          <div class="empty-skills">
                            <p>Have not added any tool yet.</p>
                          </div>
                        </div>
                      </div>
                      <div class="skill_box">
                        <div class="skill_box_header">
                          <label>Domains</label>
                        </div>
                        <div class="skill_box_body" v-if="consultant_item.skills.domains.length > 0">
                          <div class="row__item" v-for="(
                                                              value, i
                                                            ) in consultant_item.skills.domains.slice(0, 5)" :key="i">
                            <span>{{ value.name | validate }}</span>
                            <star-rating inactive-color="#C1C1C1" :read-only="true" active-color="#1BA5A4" :star-size="14"
                              :show-rating="false" v-model="value.level"></star-rating>
                          </div>
                        </div>
                        <div class="skill_box_body" v-else>
                          <div class="empty-skills">
                            <p>Have not added any domain yet.</p>
                          </div>
                        </div>
                      </div>
                      <div class="skill_box">
                        <div class="skill_box_header">
                          <label>Languages</label>
                        </div>
                        <div class="skill_box_body" v-if="consultant_item.skills.languages.length > 0">
                          <div class="row__item" v-for="(
                                                              value, i
                                                            ) in consultant_item.skills.languages.slice(0, 5)"
                            :key="i">
                            <span>{{ value.lang.name | validate }}</span>
                            <star-rating inactive-color="#C1C1C1" :read-only="true" active-color="#1BA5A4" :star-size="14"
                              :show-rating="false" v-model="value.level"></star-rating>
                          </div>
                        </div>
                        <div class="skill_box_body" v-else>
                          <div class="empty-skills">
                            <p>Have not added any language yet.</p>
                          </div>
                        </div>
                      </div>

                      <div class="skill_box">
                        <div class="skill_box_header">
                          <label>Roles</label>
                        </div>
                        <div class="skill_box_body" v-if="consultant_item.skills.roles.length > 0">
                          <div class="row__item" v-for="(
                                                              value, i
                                                            ) in consultant_item.skills.roles.slice(0, 5)" :key="i">
                            <span>{{ value.name | validate }}</span>
                            <star-rating inactive-color="#C1C1C1" :read-only="true" active-color="#1BA5A4" :star-size="14"
                              :show-rating="false" v-model="value.level"></star-rating>
                          </div>
                        </div>
                        <div class="skill_box_body" v-else>
                          <div class="empty-skills">
                            <p>Have not added any role yet.</p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="next_skills_content__wrapper">
                      <div class="skill_box">
                        <div class="skill_box_header">
                          <label>Competences</label>
                        </div>
                        <div class="skill_box_body" v-if="consultant_item.skills.competences.length > 0">
                          <div class="row__item" v-for="(
                                                              value, i
                                                            ) in consultant_item.skills.competences.slice(0, 5)"
                            :key="i">
                            <span>{{ value.name | validate }}</span>
                            <star-rating inactive-color="#C1C1C1" :read-only="true" active-color="#1BA5A4" :star-size="14"
                              :show-rating="false" v-model="value.level"></star-rating>
                          </div>
                        </div>
                        <div class="skill_box_body" v-else>
                          <div class="empty-skills">
                            <p>Have not added any competence yet.</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="consultants-item-body-option"></div>
              </div>
            </div>
          </div>
          <div class="item-view-more" :style="{ flexGrow: 1 }" v-else>
            <div v-if="main_tab == 'consultant'" class="empty-widget">
              <widgetNotFoundWidget title="No consultant selected"
                content="Please select a consultant to view their details." align="center">
                <img class="widget-img" src="@/assets/icons/member-notfound.svg" />
              </widgetNotFoundWidget>
            </div>
          </div>
        </multipane>
      </div>

    </div>

    <!-- Member management -->
    <div class="overlay" v-show="show_student_form">
      <div class="form-widget-modal member-container">
        <div class="member-header">
          <h3 v-if="!form_student.id">Add new consultant</h3>
          <h3 v-else>Update consultant</h3>
        </div>
        <div class="modal-body">
          <div class="form-widget">
            <div class="form-widget-header" v-if="!form_student.id && form_student.save_type == 'many'">
              <input type="radio" v-model="form_student.save_type" checked value="single" name="form1"
                id="single-consultant" />
              <label for="single-consultant">Add Single Consultant</label>
            </div>
            <div class="form-widget-body" v-if="form_student.save_type == 'single'">
              <div class="twin-input">
                <div class="input-group">
                  <label>First name</label>
                  <input v-model="form_student.first_name" type="text" class="input-form" />
                </div>
                <div class="input-group">
                  <label>Last name</label>
                  <input v-model="form_student.last_name" type="text" class="input-form" />
                </div>
              </div>
              <div class="twin-input">
                <div class="input-group">
                  <label>Phone</label>
                  <input v-model="form_student.phone" type="text" class="input-form" />
                </div>
                <div class="input-group">
                  <label>Email</label>
                  <input v-model="form_student.email" type="text" class="input-form" />
                </div>
              </div>
              <div class="twin-input">
                <div class="input-group">
                  <label>Location</label>
                  <map-helper v-model="form_student.location"></map-helper>
                </div>
                <div class="input-group" v-if="!form_student.id">
                  <label>Team</label>
                  <select class="input-form" v-model="form_student.selected_class">
                    <option v-for="(team, index) in department_data" :key="index" :value="team.id">
                      {{ team.name }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div class="line"></div>
          <div class="form-widget">
            <div class="form-widget-header" v-if="!form_student.id">
              <input type="radio" v-model="form_student.save_type" value="many" name="form1" id="many-consultant" />
              <label for="many-consultant">I want to add many consultants</label>
            </div>
            <div class="form-widget-body" v-if="form_student.save_type == 'many'">
              <div class="input-group">
                <label>Select Team</label>
                <select class="input-form" v-model="form_student.selected_class">
                  <option v-for="(team, index) in department_data" :key="index" :value="team.id">
                    {{ team.name }}
                  </option>
                </select>
              </div>
              <div class="template-widget">
                <a href="https://storage.googleapis.com/consultified_media/files/templates/template.xlsx" download
                  class="btn-download">Download Template</a>
                <p>
                  Download and fill the document provided. After, upload the
                  filed document using the link below
                </p>
              </div>

              <div class="upload-widget">
                <CustomerUploader @onFileSelected="(file) => {
                  if (file) {
                    form_student.selected_file = file;
                  }
                }
                  " class="uploader">
                  <button class="btn-upload">
                    Attach file <img src="@/assets/admin-icon/file.svg" />
                  </button>
                </CustomerUploader>
                <div class="selected-file" v-if="form_student.selected_file">
                  <label><img src="@/assets/admin-icon/file-grey.svg" />
                    {{ form_student.selected_file.name }}</label>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="member-managment-option">
          <c-button :loading="save_student_loading" @click="submitStudent()" class="btn-save">Save</c-button>
          <button class="btn-cancel" @click="show_student_form = false">
            Cancel
          </button>
        </div>
      </div>
    </div>
    <!-- End Member management -->

    <!-- Member management -->
    <div class="member-management" v-show="member_management_modal == true">
      <div class="member-container" v-if="!request_sent">
        <div class="member-header">
          <h3>Add consultants to manage</h3>
        </div>
        <div class="team-widget">
          <label>Select Team</label>
          <select class="input-form" v-model="selected_team_id">
            <option value="">
              Select team
            </option>
            <option v-for="(team, index) in department_data" :key="index" :value="team.id">
              {{ team.name }}
            </option>
          </select>
        </div>
        <div class="member-search-widget">
          <div class="search-container">
            <img src="@/assets/icons/search.svg" alt />
            <input type="text" placeholder="Type in to Search…" v-model="search_consultant_member" />
          </div>
          <div v-show="getSearchedPeople &&
            getSearchedPeople.length &&
            search_consultant_member
            " class="search_dropdown__body">
            <div class="dropdown__item" v-for="(person, i) in getSearchedPeople" :key="i" @click="addMate(person)">
              <img v-if="person.profile_picture" :src="$fullUrl('images/profiles/' + person.profile_picture)"
                alt="picture" />
              <img v-else src="@/assets/avatar.png" alt />
              <div class="text">
                <span>{{
                  (person.first_name + " " + person.last_name) | validate
                }}</span>
              </div>
            </div>
          </div>
          <span>Or</span>
          <div class="invite-option">
            <button class="invite-btn" @click="showInviteViaEmailModel = true">
              Invite via Email
            </button>
          </div>
        </div>
        <div class="member-body" v-if="added_member_list.length > 0">
          <!-- <label
            class="member-body-title"
          >The manager is paying monthly 1 USD For every consultants selected to manage.</label>-->
          <label class="member-body-title">Consultants selected to manage.</label>
          <div class="member-fieldset">
            <div class="collaboraters-widget">
              <div class="item" v-for="(item, i) in added_member_list" :key="i">
                <img v-if="item.picture" :src="$fullUrl('images/profiles/' + item.picture)" alt="picture"
                  class="profile-img" />
                <img v-else src="@/assets/avatar.png" alt class="profile-img" />
                <span class="name">{{ item.names | validate }}</span>
                <button class="remove-member-btn" @click="removeMate(i)">
                  <img src="@/assets/icons/close.svg" />
                </button>
              </div>
            </div>
          </div>
          <label class="sectected-member-count">{{ added_member_list.length | validate }} Consultants
            selected</label>
        </div>
        <div class="member-body" v-else>
          <label class="member-body-title">No consultants selected to manage.</label>
        </div>
        <div class="member-managment-option row">
          <widgetButton v-if="added_member_list.length > 0 || email_invites.length > 0"
            :loading="company_add_member_loading" @click="addConsultants()" class="btn-secondary">
            Done
          </widgetButton>
          <div class="h-spacer"></div>
          <button class="btn-back" @click="onCloseManageConsultant()">
            Close
          </button>
        </div>
      </div>
      <div v-else class="member-container">
        <div>
          Request was sent, Wait until selected
          {{ added_member_list.length > 1 ? "members" : "member" }} approves
          your request.
        </div>
        <div class="member-managment-option">

          <widgetButton @click="onCloseManageConsultant()" class="btn-secondary">
            Ok
          </widgetButton>
        </div>
      </div>
    </div>
    <!-- End Member management -->

    <!-- Invite Manager Modal -->
    <div class="invite-manager-overlay" v-if="show_invite_manager_modal">
      <div class="invite-manager-modal">
        <div class="invite-manager-header">
          <div class="title">Invite a new Manager</div>
          <div class="company-info">
            <img class="profile-logo" v-if="!$getLoggedUser().company_logo" :src="$fullUrl('images/profiles/' + $getLoggedUser().company_logo)
              " />
            <img v-else class="profile-logo" src="@/assets/icons/logo_avatar.svg" />
            <h3 class="company-name">{{ $getLoggedUser().company_name }}</h3>
          </div>
        </div>
        <div class="invite-manager-body">
          <h2>Please Select Manager Type</h2>
          <div class="permition-widget">
            <div class="permition-item" v-for="(item, index) in manager_perms" :key="index">
              <div class="permition-header">
                <input type="radio" :value="item.value" v-model="manager_form.permt_type" name="permit"
                  :id="'permt_item_id_' + index" />
                <label :for="'permt_item_id_' + index">{{ item.label }}</label>
              </div>
              <div class="permition-body" v-if="manager_form.permt_type == item.value">
                {{ item.description }}
              </div>
            </div>
          </div>
          <div class="options row">
            <widgetButton :loading="invite_manager_loading" @click="inviteAsManager()" class="btn-secondary">
              Accept
            </widgetButton>
            <div class="h-spacer"></div>
            <button @click="show_invite_manager_modal = false" class="btn-close">
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- End of invite manager modoal -->

    <!-- Invite via email form -->
    <div class="overlay" v-if="showInviteViaEmailModel">
      <div class="invite-via-email-modal">
        <v-card color="#D9D9D9">
          <v-layout>
            <div class="invite-via-email-card__body">
              <div class="__layout">
                <div class="div">
                  <label>Email address</label>
                  <input type="text" placeholder="E.g. abcd@youremail.com" v-model="invitation.email" />
                </div>
                <div class="div">
                  <label>Message</label>
                  <div class="msg">
                    Dear Sir/Madam,
                    <br />
                    <br />I have invited you as a consultant of our
                    organization. Please get back to me to confirm your
                    participation through the link below.
                    <br />
                    <br />Kind regards,
                    <br />
                    <br />User name
                  </div>
                </div>
                <div class="btns-2">
                  <button class="save" @click="sendInvitationViaEmail()">
                    Send
                  </button>
                  <button class="cancel" @click="showInviteViaEmailModel = false">
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </v-layout>
        </v-card>
      </div>
    </div>

    <!-- Transfer Student -->
    <widgetModal v-if="showTransferModal && consultant_item" width="550px" title="Change Team"
      subtitle="Fill in the information below to change the consultant to another team" btnlefttext="Save Changes"
      btncentertext="Cancel" btnrighttext="Add Multiple LIA" :leftloading="loadingTransfer" :rightloading="false"
      :centerloading="false" :footerhidden="false" footer_padding="10px 18px 30px 30px" header_padding="30px 0px 0px 31px"
      body_padding="0px 30px" :oldhiderightbtn="false" :hiderightbtn="true" @onLeftClick="onConfirmConsultantTransfer()"
      @onCenterClick="showTransferModal = false">
      <div class="widget-modal-body-noscoll">
        <widgetInputWrapper title="Current team">
          <p v-if="consultant_item.teams.length > 0">{{ consultant_item.teams[0].name | validate }}</p>
          <p v-else>Not Set</p>
        </widgetInputWrapper>
        <widgetInputWrapper title="Select team">
          <select class="input-form" v-model="form_transfer.teamId">
            <option v-for="(team, index) in department_data" :key="index" :value="team.id">
              {{ team.name }}
            </option>
          </select>
        </widgetInputWrapper>
      </div>
    </widgetModal>


  </div>
</template>

<script>
import appDialog from "@/components/Dialog/AppDialog.vue";
import { eventBus } from "@/main";
import { mapGetters } from "vuex";
export default {
  name: "consultants",
  components: {
    appDialog,
  },
  props: {},
  data: () => {
    return {
      user_loading: false,
      showInviteViaEmailModel: false,
      request_sent: false,
      member_management_modal: false,
      consultant_list: true,
      tab: "all",
      main_tab: "consultant",
      manage_consultant_component: false,
      search_consultant_member: "",
      added_member_list: [],
      selected_team_id: "",
      company_add_member_loading: false,
      user: {
        company_info: {},
        manager_info: {},
        manager_profile: {},
        consultants: [],
      },
      search_member_input: "",
      selected_id: null,
      consultant_item: null,
      manager_perms: [
        {
          label: "Admin Manager",
          value: "super-manager",
          checked: false,
          description:
            "As the Admin Manager, one will access full control and administration of the organization.",
        },
        {
          label: "Division Manager",
          value: "department-manager",
          checked: false,
          description:
            "As the Department Manager, one will interact with departments, teams as well as consultants profiles, create leads, invite consultants and instructors, etc. However, some of the features requires the Admin approval.",
        },
        {
          label: "Team Manager",
          value: "team-manager",
          checked: false,
          description:
            "As Team Manager, one have access to a team their consultants. They will be developing and carrying out management process. They will be able to manage consultants profiles, create leads, invite consultant.",
        },
      ],
      manager_form: {
        change: false,
        permt_type: null,
        company_id: null,
        user_id: null,
      },
      show_student_form: false,
      save_student_loading: false,
      form_student: {
        save_type: "single",
        id: null,
        first_name: "",
        last_name: "",
        phone: "",
        email: "",
        location: "",
        selected_class: null,
        selected_file: null,
      },
      show_manager_form: false,
      save_manager_loading: false,
      form_manager: {
        save_type: "single",
        id: null,
        first_name: "",
        last_name: "",
        phone: "",
        email: "",
        location: "",
        selected_class: null,
        selected_file: null,
      },
      show_invite_manager_modal: false,
      invite_manager_loading: false,
      department_data: [],
      selected_view_filter: "",
      view_filter: [
        {
          value: "all",
          name: "All",
        },
        {
          value: "avail",
          name: "Available",
        },
      ],
      invitation: {
        target: "",
        email: "",
        note: "",
        type: "",
        id: 0,
      },
      email_invites: [],
      form_transfer: {
        id: null,
        teamId: null,
      },
      showTransferModal: false,
      loadingTransfer: false,
    };
  },
  mounted() {
    let vm = this;
    vm.getAllStartData();
    vm.getTeamDepData();
  },
  computed: {
    ...mapGetters(["getSearchedPeople"]),
  },
  watch: {
    search_consultant_member: function (query) {
      this.searchPeople(query);
    },
    selected_view_filter(val) {
      let vm = this;
      vm.tab = val;
    },
  },
  methods: {
    transferConsultant(item) {
      let vm = this;
      vm.viewItem(item);
      vm.form_transfer.id = item.id;
      vm.form_transfer.teamId = item.teams.length > 0 ? item.teams[0].id : null;
      vm.showTransferModal = true;
    },
    onConfirmConsultantTransfer() {
      let vm = this;
      vm.loadingTransfer = true;
      vm.$store
        .dispatch("COMPANY_TRANSFER_CONSULTANT", vm.form_transfer)
        .then((responce) => {
          vm.loadingTransfer = false;
          vm.showTransferModal = false;
          vm.getAllStartData();
          vm.$notify({
            group: "status",
            title: "Success",
            text: "Consultant was transfered",
            type: "success",
            duration: 3000,
          });
        })
        .catch((error) => {
          vm.loadingTransfer = false;
          vm.$notify({
            group: "status",
            title: "Warning",
            text: "Consultant not transfered, Please try again.",
            type: "warn",
            duration: 3000,
          });
          console.log(error);
        });
    },
    sendInvitationViaEmail() {
      let vm = this;
      vm.showInviteViaEmailModel = false;
      vm.email_invites.push(vm.invitation);
    },
    updateInstuctor(item) {
      let vm = this;
      vm.form_manager.save_type = "single";
      vm.form_manager.id = item.id;
      vm.form_manager.first_name = item.first_name;
      vm.form_manager.last_name = item.last_name;
      vm.form_manager.phone = item.profile.phone;
      vm.form_manager.email = item.email;
      vm.form_manager.location = item.profile.address;
      vm.form_manager.selected_class = null;
      vm.form_manager.selected_file = null;
      vm.show_manager_form = true;
    },
    updateConsultant(item) {
      let vm = this;
      vm.form_student.save_type = "single";
      vm.form_student.id = item.id;
      vm.form_student.first_name = item.first_name;
      vm.form_student.last_name = item.last_name;
      vm.form_student.phone = item.profile.phone;
      vm.form_student.email = item.email;
      vm.form_student.location = item.profile.address;
      vm.form_student.selected_class = null;
      vm.form_student.selected_file = null;
      vm.show_student_form = true;
    },
    validateRoleName(name) {
      if (name == "super-manager") {
        return "Admin manager";
      } else if (name == "team-manager") {
        return "Team manager";
      } else if (name == "department-manager") {
        return "Division manager";
      }
    },
    changePermission(item) {
      let vm = this;
      vm.manager_form.company_id = vm.user.company_info.id;
      vm.manager_form.user_id = item.id;
      vm.manager_form.permt_type = item.roles[0].name;
      vm.manager_form.change = true;
      vm.show_invite_manager_modal = true;
      vm.consultant_item = item;
    },
    changeUserPermssion() {
      let vm = this;
      vm.invite_manager_loading = true;
      vm.$store
        .dispatch("COMPANY_CONSULTANT_CHANGE_PERMISSION", vm.manager_form)
        .then((responce) => {
          vm.invite_manager_loading = false;
          vm.show_invite_manager_modal = false;
          vm.getAllStartData();
          vm.$notify({
            group: "status",
            title: "Success",
            text: "Permission was changed",
            type: "success",
            duration: 3000,
          });
        })
        .catch((error) => {
          vm.invite_manager_loading = false;
          vm.$notify({
            group: "status",
            title: "Warning",
            text: "Permission not set, Please try again.",
            type: "warn",
            duration: 3000,
          });
          console.log(error);
        });
    },
    removeManager(id) {
      let vm = this;
      vm.$store
        .dispatch("REMOVE_MANAGER_FROM_COMPANY", {
          company_id: vm.user.company_info.id,
          user_id: id,
        })
        .then((responce) => {
          vm.getAllStartData();
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getTeamDepData() {
      let vm = this;
      vm.$store
        .dispatch("GET_ALL_USER_INFO")
        .then((response) => {
          response.data.forEach((item) => {
            item.teams.forEach((team) => {
              vm.department_data.push(team);
            });
          });
        })
        .catch((error) => {
          console.error({ error });
        });
    },
    showinviteManagerModal(id) {
      let vm = this;
      vm.manager_form.company_id = vm.user.company_info.id;
      vm.manager_form.user_id = id;
      vm.manager_form.change = false;
      vm.show_invite_manager_modal = true;
    },
    inviteAsManager() {
      let vm = this;
      vm.invite_manager_loading = true;
      if (!vm.manager_form.change) {
        vm.$store
          .dispatch("COMPANY_INVITE_CONSULTANT_AS_MANAGER", vm.manager_form)
          .then((responce) => {
            vm.invite_manager_loading = false;
            vm.show_invite_manager_modal = false;
            vm.getAllStartData();
            vm.$notify({
              group: "status",
              title: "Success",
              text: "Now invite was sent",
              type: "success",
              duration: 3000,
            });
          })
          .catch((error) => {
            vm.invite_manager_loading = false;
            vm.$notify({
              group: "status",
              title: "Warning",
              text: "Invite not sent, Please try again.",
              type: "warn",
              duration: 3000,
            });
            console.log(error);
          });
      } else {
        vm.$store
          .dispatch("COMPANY_CONSULTANT_CHANGE_PERMISSION", vm.manager_form)
          .then((responce) => {
            vm.invite_manager_loading = false;
            vm.show_invite_manager_modal = false;
            vm.getAllStartData();
            vm.$notify({
              group: "status",
              title: "Success",
              text: "Permission was changed",
              type: "success",
              duration: 3000,
            });
          })
          .catch((error) => {
            vm.invite_manager_loading = false;
            vm.$notify({
              group: "status",
              title: "Warning",
              text: "Permission not set, Please try again.",
              type: "warn",
              duration: 3000,
            });
            console.log(error);
          });
      }
    },
    viewItem(item) {
      let vm = this;
      vm.user.consultants.forEach((item) => {
        eventBus.$set(item, "active", false);
        return item;
      });
      vm.user.managers?.forEach((item) => {
        eventBus.$set(item, "active", false);
        return item;
      });
      vm.user.available_consultants.forEach((item) => {
        eventBus.$set(item, "active", false);
        return item;
      });
      item.active = true;
      vm.consultant_item = item;
    },
    searchCompanyMember() {
      let vm = this;
      let query = vm.search_member_input;
      if (vm.search_member_input) {
        vm.user_loading = true;
        vm.$store
          .dispatch("SEARCH_FOR_COMPANY_MEMBERS", { query: query, type: 'consultant' })
          .then((responce) => {
            vm.user_loading = false;
            let consultant_data = vm.processSkills(responce.data);
            eventBus.$set(vm.user, "consultants", consultant_data);
            vm.user.consultants = vm.user.consultants
              .filter((item) => {
                return item.profile;
              })
              .sort((start, end) => {
                return start.order - end.order;
              });
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        vm.getAllStartData();
      }
    },
    getAllStartData() {
      let vm = this;
      vm.user_loading = true;
      vm.$store
        .dispatch("GET_ME_USER_COMPANY")
        .then((responce) => {
          vm.user_loading = false;
          vm.user = responce.data;
          // Consultant list
          let consultant_data = vm.processSkills(vm.user.consultants);
          eventBus.$set(vm.user, "consultants", consultant_data);
          vm.user.consultants.forEach((item) => {
            eventBus.$set(item, "active", false);
            return item;
          });
          vm.user.consultants = vm.user.consultants.map((item) => {
            item.profile = item.profile ? item.profile : {};
            return item;
          })
            .filter((item) => {
              return item.profile;
            })
            .sort((start, end) => {
              return start.order - end.order;
            });


          // Available consultant list
          let available_consultants = vm.processSkills(
            vm.user.available_consultants
          );
          eventBus.$set(
            vm.user,
            "available_consultants",
            available_consultants
          );
          vm.user.available_consultants.forEach((item) => {
            eventBus.$set(item, "active", false);
            return item;
          });
          vm.user.available_consultants = vm.user.available_consultants.map((item) => {
            item.profile = item.profile ? item.profile : {};
            return item;
          })
            .filter((item) => {
              return item.profile;
            })
            .sort((start, end) => {
              return start.order - end.order;
            });
          if (window.innerWidth > 500) {
            if (vm.user.consultants.length > 0) {
              vm.viewItem(vm.user.consultants[0]);
            }
          }
        })
        .catch((error) => {
          vm.user_loading = false;
        });
    },
    removeConsultant(item) {
      let vm = this;
      vm.$store
        .dispatch("REMOVE_MEMBER_FROM_COMPANY", {
          company_id: vm.user.company_info.id,
          user_id: item.id,
          account_type: item.account_type,
        })
        .then((responce) => {
          vm.getAllStartData();
        })
        .catch((error) => {
          console.log(error);
        });
    },
    processSkills(consultants) {
      return consultants.map((item) => {
        let skills = {
          tools: [],
          domains: [],
          languages: [],
          competences: [],
          roles: [],
        };
        if (item.skills.length && item.skills.length > 0) {
          item.skills.forEach((skill) => {
            skill.tools.forEach((item) => {
              let obj = {
                name: item.name,
                priority: item.priority,
                level: parseInt(item.priority),
              };
              skills.tools.push(obj);
            });
            skill.domains.forEach((item) => {
              let obj = {
                name: item.name,
                priority: item.priority,
                level: parseInt(item.priority),
              };
              skills.domains.push(obj);
            });
            skill.competences.forEach((item) => {
              let obj = {
                name: item.name,
                priority: item.priority,
                level: parseInt(item.priority),
              };
              skills.competences.push(obj);
            });
            skill.roles.forEach((item) => {
              let obj = {
                name: item.name,
                priority: item.priority,
                level: parseInt(item.priority),
              };
              skills.roles.push(obj);
            });
            skill.languages.forEach((item) => {
              if (item.lang) {
                let obj = {
                  lang: { name: item.lang.name },
                  level: parseInt(item.level),
                };
                skills.languages.push(obj);
              }
            });
          });
        }
        eventBus.$set(item, "skills", skills);
        return item;
      });
    },
    submitStudent() {
      let vm = this;
      vm.save_student_loading = true;
      let form_data = new FormData();
      form_data.append("id", vm.form_student.id);
      form_data.append("save_type", vm.form_student.save_type);
      form_data.append("first_name", vm.form_student.first_name);
      form_data.append("last_name", vm.form_student.last_name);
      form_data.append("phone", vm.form_student.phone);
      form_data.append("email", vm.form_student.email);
      form_data.append("location", vm.form_student.location);
      form_data.append("selected_class", vm.form_student.selected_class);
      if (vm.form_student.selected_file) {
        form_data.append(
          "selected_file",
          vm.form_student.selected_file,
          vm.form_student.selected_file.name
        );
      }
      if (!vm.form_student.id) {
        vm.$store
          .dispatch("ADD_SCHOOL_STUDENT", form_data)
          .then((responce) => {
            vm.$notify({
              group: "status",
              title: "Success",
              text: "New consultant was added",
              type: "success",
              duration: 3000,
            });
            vm.save_student_loading = false;
            vm.show_student_form = false;
            vm.getAllStartData();
          })
          .catch(({ response }) => {
            vm.$notify({
              group: "status",
              title: "Warning",
              text: response.data.error.message,
              type: "warn",
              duration: 3000,
            });
            vm.save_student_loading = false;
          });
      } else {
        vm.$store
          .dispatch("UPDATE_SCHOOL_STUDENT", form_data)
          .then((responce) => {
            vm.$notify({
              group: "status",
              title: "Success",
              text: "Consultant was updated",
              type: "success",
              duration: 3000,
            });
            vm.save_student_loading = false;
            vm.show_student_form = false;
            vm.getAllStartData();
          })
          .catch(({ response }) => {
            vm.$notify({
              group: "status",
              title: "Warning",
              text: response.data.error.message,
              type: "warn",
              duration: 3000,
            });
            vm.save_student_loading = false;
          });
      }
    },
    submitManager() {
      let vm = this;
      vm.save_manager_loading = true;
      let form_data = new FormData();
      form_data.append("id", vm.form_manager.id);
      form_data.append("save_type", vm.form_manager.save_type);
      form_data.append("first_name", vm.form_manager.first_name);
      form_data.append("last_name", vm.form_manager.last_name);
      form_data.append("phone", vm.form_manager.phone);
      form_data.append("email", vm.form_manager.email);
      form_data.append("location", vm.form_manager.location);
      form_data.append("selected_class", vm.form_manager.selected_class);
      if (vm.form_manager.selected_file) {
        form_data.append(
          "selected_file",
          vm.form_manager.selected_file,
          vm.form_manager.selected_file.name
        );
      }
      if (!vm.form_manager.id) {
        vm.$store
          .dispatch("ADD_SCHOOL_MANAGER", form_data)
          .then((responce) => {
            vm.$notify({
              group: "status",
              title: "Success",
              text: "Invitation was sent, wait for manager to approve",
              type: "success",
              duration: 3000,
            });
            vm.save_manager_loading = false;
            vm.show_manager_form = false;
            vm.getAllStartData();
          })
          .catch((error) => {
            vm.$notify({
              group: "status",
              title: "Warning",
              text: "Error while adding new manager, Please try again.",
              type: "warn",
              duration: 3000,
            });
            vm.save_manager_loading = false;
          });
      } else {
        vm.$store
          .dispatch("UPDATE_SCHOOL_MANAGER", form_data)
          .then((responce) => {
            vm.$notify({
              group: "status",
              title: "Success",
              text: "Manager have been updated",
              type: "success",
              duration: 3000,
            });
            vm.save_manager_loading = false;
            vm.show_manager_form = false;
            vm.getAllStartData();
          })
          .catch((error) => {
            vm.$notify({
              group: "status",
              title: "Warning",
              text: "Error while updating manager, Please try again.",
              type: "warn",
              duration: 3000,
            });
            vm.save_manager_loading = false;
          });
      }
    },
    addConsultants() {
      let vm = this;
      vm.company_add_member_loading = true;
      let data = vm.added_member_list.map((item) => {
        return item.id;
      });
      vm.$store
        .dispatch("ADD_COMPANY_MEMBER", {
          members_added: data,
          crm_team_id: vm.selected_team_id,
          invites: vm.email_invites,
        })
        .then((responce) => {
          vm.company_add_member_loading = false;
          vm.request_sent = true;
        })
        .catch((error) => {
          vm.company_add_member_loading = false;
        });
    },
    removeMate(i) {
      let vm = this;
      vm.added_member_list.splice(i, 1);
    },
    addMate(member) {
      let vm = this;
      let obj = {
        id: member.id,
        names: member.first_name + " " + member.last_name,
        picture: member.profile_picture,
      };
      if (!vm.added_member_list.map((item) => item.id).includes(member.id)) {
        vm.added_member_list.push(obj);
        vm.search_consultant_member = "";
      } else {
        vm.$notify({
          group: "status",
          title: "Warning",
          text: "Already selected, Please try other.",
          type: "warn",
          duration: 3000,
        });
      }
    },
    searchPeople(query) {
      this.$store.dispatch("SEARCH_FOR_PROJECT_MEMBERS", { query: query });
    },
    onCloseManageConsultant() {
      let vm = this;
      vm.selected_id = null;
      vm.manage_consultant_component = false;
      vm.member_management_modal = false;
      vm.consultant_list = true;
      vm.getAllStartData();
    },
    manageConsultant(id) {
      let vm = this;
      vm.$router.push({
        name: "organization",
        params: { type: "manage" },
        query: {
          profile_type: "student",
          id: id,
          company_id: vm.$getLoggedUser().company_id,
        },
      });
    },
    addMember() {
      let vm = this;
      vm.form_student = {
        save_type: "single",
        id: null,
        first_name: "",
        last_name: "",
        phone: "",
        email: "",
        location: "",
        selected_class: null,
        selected_file: null,
      };
      //vm.show_student_form = true;
      vm.request_sent = false;
      vm.selected_team_id = "";
      vm.search_consultant_member = "";
      vm.added_member_list = [];
      vm.member_management_modal = true;
    },
    addManager() {
      let vm = this;
      vm.form_manager = {
        save_type: "single",
        id: null,
        first_name: "",
        last_name: "",
        phone: "",
        email: "",
        location: "",
        selected_class: null,
        selected_file: null,
      };
      vm.show_manager_form = true;
    },
  },
};
</script>
<style lang="scss" scoped>
.parent-container {
  display: flex;
  flex-direction: column;
  height: 100%;

  .parent-toolbar {
    position: absolute;
    z-index: 999;
    top: 5px;
    left: 5px;
    right: 5px;
  }

  .company-profile-wrapper {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;

    .company-profile-container {
      padding: 1px;
      width: 100%;
      position: relative;
      height: 100%;
      display: flex;
      flex-direction: column;

      .custom-resizer {
        height: 100%;

        .items {
          height: 100%;
          min-width: 50%;
          width: 50%;
          background: #ffffff;
          border-radius: 5px;
          display: flex;
          flex-direction: column;

          .company-profile-body {
            border-radius: 5px;
            display: flex;
            flex-direction: column;
            height: 100%;

            .list-container {
              display: flex;
              flex-direction: column;
              height: 100%;

              .table-label {
                font-weight: 400;
                font-size: 16px;
                color: #000000;
                display: flex;
                align-items: center;
                padding: 0px 10px;
                height: 50px;
              }

              .table-container {
                height: calc(100% - 50px);
                overflow-y: auto;
                padding: 0px 10px;

                .table-data {
                  border-collapse: collapse;
                  border-spacing: 0;

                  tr {
                    .table-th-stick-top {
                      position: sticky;
                      top: 0;
                    }

                    &.th-tr {
                      background: #fff;

                      th {
                        font-weight: 400;
                        font-size: 14px;
                        color: #969696;
                        z-index: 999999;
                      }
                    }

                    &.row-data {
                      border-bottom: 1px solid #ddd;
                    }

                    &:hover {
                      cursor: pointer;
                    }

                    &.active {
                      background: rgb(248, 248, 248);
                    }

                    th {
                      border-bottom: none;

                      &.center {
                        display: flex;
                        align-content: center;

                        input {
                          position: relative;
                          top: 0px;
                          margin-right: 5px;
                          margin: 0px 20px;
                        }
                      }

                      &.text-center {
                        text-align: center;
                      }
                    }

                    td {
                      text-align: left;
                      border-bottom: none;
                      font-size: 13px;
                      color: rgb(28, 28, 28);

                      .checkbox {
                        margin: 0px 20px;
                      }

                      .profile-content {
                        .profile-alphabet {
                          margin-right: 5px;
                          height: 30px !important;
                          width: 30px !important;
                          background: #1ba5a4;

                          span {
                            font-size: 10px;
                            color: #fff;
                          }
                        }

                        .names-location {
                          display: flex;
                          flex-direction: column;

                          .name {
                            font-size: 13px;
                          }

                          .location {
                            font-size: 12px;
                            color: #707070;
                            overflow: hidden;
                            text-decoration: none;
                            text-overflow: ellipsis;
                            white-space: nowrap;
                            width: 150px;
                          }
                        }

                        .profile-image {
                          margin-right: 5px;
                          height: 30px !important;
                          width: 30px !important;
                          border-radius: 50%;
                          object-fit: cover;
                        }
                      }

                      .email-phone {
                        display: flex;
                        flex-direction: column;

                        .email {
                          font-size: 12px;
                        }

                        .phone {
                          font-size: 9px;
                          color: #707070;
                        }
                      }

                      .menu {
                        width: 100%;
                        display: flex;
                        justify-content: center;

                        button {
                          padding: 0px;
                          position: relative;
                          left: -3px;

                          img {
                            width: 15px;
                          }
                        }
                      }

                      &:first-child {
                        border-top-left-radius: 5px;
                        border-bottom-left-radius: 5px;
                      }

                      &:last-child {
                        border-top-right-radius: 5px;
                        border-bottom-right-radius: 5px;
                      }

                      &.center {
                        text-align: center;
                      }
                    }
                  }
                }

                .loading-paginated-items {
                  height: 50px;
                  position: relative;
                }
              }
            }
          }

          .empty-widget {
            padding: 0px 20px;

            .empty-widget-body {
              height: 350px;
              display: flex;
              align-items: center;
              justify-content: center;
              flex-direction: column;
              padding: 0px 0px;

              p {
                text-align: center;
                width: 300px;
              }

              .add-btn {
                width: 180px;
                height: 45px;
                background: #1890a9 0% 0% no-repeat padding-box;
                border-radius: 4px;
                color: #fff;
                outline: none;
                margin-right: 20px;
                display: center;
                justify-content: center;
              }
            }
          }
        }

        .multipane-resizer {
          width: 15px;
        }

        .item-view-more {
          height: 100%;
          overflow-y: auto;
          padding: 20px;
          padding-bottom: 40px;
          background: #fff;
          border-radius: 5px;
          width: 400px;
          min-width: 400px;
          max-width: 50%;

          @media (min-width: 300px) and (max-width: 630px) {
            position: fixed;
            top: 0px;
            left: 0px;
            right: 0px;
            bottom: 0px;
            z-index: 999999;
            display: flex;
            justify-content: center;
            padding-right: 0px;
            background: #fff;
          }

          .consultants-item {
            margin-bottom: 10px;
            position: relative;

            @media (min-width: 300px) and (max-width: 630px) {
              padding-top: 40px;
            }

            .consultants-item-header {
              display: flex;
              justify-content: space-between;
              align-items: center;

              @media (min-width: 300px) and (max-width: 630px) {
                padding: 10px 17px;
                position: fixed;
                top: 0px;
                left: 0px;
                right: 0px;
                background: #fff;
              }

              .consultants-item-header-options {
                .close-btn {
                  display: none;
                  border: none;
                  background: none;
                }
              }
            }

            .consultants-item-body {
              padding-bottom: 25px;

              .consultants-info {
                h5 {
                  text-align: left;
                  color: #6e6e6e;
                  font-size: 13px;
                  margin-bottom: 0px;
                }

                p {
                  text-align: left;
                  color: #000;
                  font-size: 11px;
                  margin-top: 4px;
                }

                .description {
                  margin-top: -8px;

                  p {
                    font-size: 11px !important;
                  }
                }

                .skills-widget {
                  margin-top: 5px;

                  .skills_content__wrapper {
                    display: grid;
                    grid-template-columns: calc(50% - 5px) calc(50% - 5px);
                    grid-gap: 10px;
                    margin-bottom: 10px;

                    @media (min-width: 300px) and (max-width: 630px) {
                      grid-template-columns: 1fr;
                    }

                    .skill_box {
                      min-width: 0;
                      display: flex;
                      flex-direction: column;
                      width: 100%;
                      background: #f3f3f3;
                      border-radius: 10px;

                      .skill_box_header {
                        height: 50px;
                        display: flex;
                        align-items: center;
                        justify-content: space-around;
                        padding: 0px 15px;

                        label {
                          color: #0884af;
                          width: 100%;
                          font-size: 13px;
                        }
                      }

                      .skill_box_body {
                        padding: 0px 15px;

                        .empty-skills {
                          display: flex;
                          flex-direction: column;
                          align-items: center;
                          min-height: 80px;
                          justify-content: center;

                          p {
                            text-align: center;
                            margin-bottom: 20px;
                            color: #8d8d8d;
                          }

                          button {
                            width: 133px;
                            height: 36px;
                            background: #1890a9 0% 0% no-repeat padding-box;
                            border-radius: 5px;
                            color: #fff;
                          }
                        }

                        .row__item {
                          display: flex;
                          margin-bottom: 10px;
                          justify-content: space-between;
                          width: 100%;

                          span {
                            color: #000000;
                            font-weight: normal;
                            margin-top: 2px;
                            font-size: 11px;
                            overflow: hidden;
                            text-decoration: none;
                            text-overflow: ellipsis;
                            white-space: nowrap;
                            text-transform: capitalize;
                          }
                        }
                      }
                    }
                  }

                  .next_skills_content__wrapper {
                    display: grid;
                    grid-template-columns: 1fr;
                    grid-gap: 10px;

                    @media (min-width: 300px) and (max-width: 630px) {
                      grid-template-columns: 1fr;
                    }

                    .skill_box {
                      min-width: 0;
                      display: flex;
                      flex-direction: column;
                      width: 100%;
                      background: #f3f3f3;
                      border-radius: 10px;
                      margin-bottom: 15px;

                      .skill_box_header {
                        height: 50px;
                        display: flex;
                        align-items: center;
                        justify-content: space-around;
                        padding: 0px 15px;

                        label {
                          color: #0884af;
                          width: 100%;
                          font-size: 13px;
                        }
                      }

                      .skill_box_body {
                        padding: 0px 15px;

                        .empty-skills {
                          display: flex;
                          flex-direction: column;
                          align-items: center;
                          min-height: 80px;
                          justify-content: center;

                          p {
                            text-align: center;
                            margin-bottom: 20px;
                            color: #8d8d8d;
                          }

                          button {
                            width: 133px;
                            height: 36px;
                            background: #1890a9 0% 0% no-repeat padding-box;
                            border-radius: 5px;
                            color: #fff;
                          }
                        }

                        .row__item {
                          margin-bottom: 10px;
                          display: flex;
                          justify-content: space-between;
                          width: 100%;

                          span {
                            color: #000000;
                            font-weight: normal;
                            margin-top: 2px;
                            font-size: 11px;
                            overflow: hidden;
                            text-decoration: none;
                            text-overflow: ellipsis;
                            white-space: nowrap;
                            text-transform: capitalize;
                          }
                        }
                      }
                    }
                  }
                }
              }

              .consultants-item-body-option {
                display: flex;
                justify-content: flex-end;

                .toogle-panel-btn {
                  padding: 1px 9px;
                  font-size: 30px;
                  background: transparent;
                  border: none;
                  outline: none;
                  cursor: pointer;
                  color: #ccc;
                  height: 36px;
                  width: 19px;
                  padding: 0;
                  height: 22px;
                  font-size: 20px;
                  position: relative;
                  top: -3px;
                  right: -5px;
                }
              }
            }
          }

          .empty-widget {
            display: flex;
            align-items: center;
            justify-content: center;
            padding-top: 80px;
          }
        }
      }
    }
  }

  .invite-manager-overlay {
    width: 100%;
    padding-right: 15px;
    position: fixed;
    top: 0px;
    bottom: 0px;
    left: 0px;
    right: 0px;
    background: rgba($color: #000000, $alpha: 0.6);
    padding-top: 100px;
    z-index: 999999999;

    .invite-manager-modal {
      background: rgb(236, 236, 236);
      padding: 30px 30px;
      width: 100%;
      border-radius: 5px;
      width: 600px;
      display: block;
      margin: 0 auto;

      @media (min-width: 300px) and (max-width: 630px) {
        padding: 30px 20px;
      }

      .invite-manager-header {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .title {
          color: #0884af;
          font-size: 20px;
        }

        .company-info {
          display: flex;
          align-items: center;

          img {
            width: 40px;
            height: 40px;
            object-fit: cover;
            border-radius: 50%;
            margin-right: 6px;
          }

          .company-name {
            color: #0884af;
            font-size: 16px;
          }
        }
      }

      .invite-manager-body {
        background: #fff;
        border-radius: 5px;
        padding: 15px;

        h2 {
          font-size: 18px;
          color: #676767;
          margin: 0px;
        }

        .permition-widget {
          margin-top: 15px;

          .permition-item {
            margin-bottom: 20px;

            .permition-header {
              display: flex;
              align-items: center;

              input {
                margin-right: 15px;
                margin-top: -4px;
              }
            }

            .permition-body {
              padding-top: 10px;
              padding-left: 30px;
              color: #737373;
              font-style: italic;
            }
          }
        }

        .options {
          display: flex;

          .btn-submit {
            width: 148px;
            height: 40px;
            background: #1ba5a4;
            border-radius: 5px;
            color: #fff;
            margin-right: 22px;
            display: flex;
            align-items: center;
            justify-content: center;
          }

          .btn-close {
            color: #1ba5a4;
          }
        }
      }
    }
  }

  .member-management {
    width: 100%;
    padding-right: 15px;
    position: fixed;
    top: 0px;
    bottom: 0px;
    left: 0px;
    right: 0px;
    background: rgba($color: #000000, $alpha: 0.6);
    padding-top: 100px;
    z-index: 999999999;

    .member-container {
      background: #fff;
      padding: 30px 30px;
      width: 100%;
      border-radius: 5px;
      width: 450px;
      display: block;
      margin: 0 auto;

      @media (min-width: 300px) and (max-width: 630px) {
        padding: 30px 20px;
      }

      .member-header {
        width: 100%;
        padding-bottom: 30px;

        h3 {
          font-size: 20px;
          margin: 0px;
        }
      }

      .team-widget {
        display: flex;
        flex-direction: column;

        .input-form {
          border: 1px solid rgb(185, 185, 185);
          height: 40px;
          margin-bottom: 10px;
          outline: none;
          border-radius: 5px;
          padding: 0px 10px;
        }
      }

      .member-search-widget {
        display: flex;
        align-items: center;
        grid-column-gap: 30px;
        padding-bottom: 30px;
        position: relative;

        @media (min-width: 300px) and (max-width: 630px) {
          grid-template-columns: 100%;
          grid-row-gap: 20px;
        }

        .search-container {
          border: 1px solid #ccc;
          height: 45px;
          width: 100%;
          display: flex;
          align-items: center;
          padding: 0px 10px;
          border-radius: 5px;

          img {
            width: 25px;
            height: 25px;
          }

          input {
            height: 42px;
            width: 100%;
            padding-left: 15px;
            outline: none;
          }
        }

        .search_dropdown__body {
          position: absolute;
          top: 45px;
          width: 100%;
          background: #fff;
          z-index: 999;
          box-shadow: 0px 4px 7px #ccc;
          height: 250px;
          overflow-y: auto;
          border-radius: 5px;

          .dropdown__item {
            display: flex;
            align-items: center;
            border-bottom: 1px solid #e8e8e8;
            padding: 20px 10px;
            cursor: pointer;

            &:hover {
              background: #e8e8e8;
            }

            img {
              height: 30px;
              width: 30px;
              object-fit: cover;
              margin-right: 15px;
              border-radius: 50%;
            }

            .text {
              span {
                font-size: 15px;
              }
            }
          }
        }

        .invite-option {
          display: flex;
          flex-direction: column;

          span {
            color: #b3b3b3;
            margin: 20px 0px;
          }

          .invite-btn {
            width: 127px;
            height: 45px;
            background: #1890a9 0% 0% no-repeat padding-box;
            border-radius: 4px;
            color: #fff;
            outline: none;
          }
        }
      }

      .member-body {
        .member-body-title {
          font-size: 12px;
          color: #031019;
        }

        .member-fieldset {
          border: 1px solid #c2c2c2;
          border-radius: 5px;
          padding: 15px;

          .collaboraters-widget {
            padding: 10px 0px;
            display: flex;
            flex-wrap: wrap;

            .item {
              background: #1ba5a4 0% 0% no-repeat padding-box;
              border-radius: 20px;
              display: flex;
              align-items: center;
              padding: 4px 4px;
              margin-right: 8px;
              margin-bottom: 8px;
              position: relative;

              .profile-img {
                width: 26px;
                height: 26px;
                border-radius: 50%;
                margin-right: 5px;
              }

              .name {
                color: #fff;
                margin-right: 10px;
              }

              .remove-member-btn {
                background: crimson;
                border-radius: 50%;
                height: 20px;
                width: 20px;
                display: flex;
                align-items: center;
                justify-content: center;
                position: absolute;
                top: -11px;
                right: -7px;
              }
            }
          }
        }

        .sectected-member-count {
          font-size: 14px;
          color: #6e6e6e;
          margin-top: 10px;
          display: block;
        }
      }

      .member-managment-option {
        padding-top: 20px;
        display: flex;
        justify-content: flex-start;

        .btn-save {
          width: 100px;
          height: 45px;
          background: #1890a9 0% 0% no-repeat padding-box;
          border-radius: 4px;
          color: #fff;
          outline: none;
          margin-right: 20px;
          display: flex;
          justify-content: center;
          align-items: center;
        }

        .btn-back {
          height: 45px;
          border-radius: 4px;
          color: #1890a9;
          outline: none;
        }
      }
    }
  }

  .overlay {
    .member-container {
      background: #fff;
      padding: 30px 30px;
      border-radius: 5px;
      width: 450px;
      margin: 0 auto;
      display: flex;
      flex-direction: column;

      @media (min-width: 300px) and (max-width: 630px) {
        padding: 30px 20px;
      }

      .member-header {
        width: 100%;
        padding-bottom: 30px;

        h3 {
          font-size: 20px;
          margin: 0px;
        }
      }

      .modal-body {
        .form-widget {
          .form-widget-header {
            display: flex;
            align-items: center;
            margin-bottom: 20px;

            input[type="radio"] {
              position: relative;
              top: -3px;
              left: -5px;
              margin-right: 8px;
            }

            img {
              margin-left: 5px;
            }

            label {
              cursor: pointer;
            }
          }

          .form-widget-body {
            .template-widget {
              margin-bottom: 30px;

              .btn-download {
                width: 200px;
                height: 45px;
                background: #1890a9 0% 0% no-repeat padding-box;
                border-radius: 4px;
                color: #fff;
                outline: none;
                margin-right: 20px;
                display: flex !important;
                justify-content: center;
                align-items: center;
              }
            }

            .upload-widget {
              display: flex;
              align-items: center;

              .uploader {
                width: 200px;

                .btn-upload {
                  width: 200px;
                  height: 45px;
                  background: #1890a9 0% 0% no-repeat padding-box;
                  border-radius: 4px;
                  color: #fff;
                  outline: none;
                  margin-right: 20px;
                  display: flex !important;
                  justify-content: center;
                  align-items: center;

                  img {
                    margin-left: 6px;
                    width: 20px;
                    position: relative;
                    top: -1px;
                  }
                }
              }

              .selected-file {
                display: flex;
                align-items: center;

                img {
                  position: relative;
                  top: 3px;
                }
              }
            }
          }
        }

        .line {
          border-bottom: 1px solid #ddd;
          margin: 10px 0px;
        }
      }

      .member-managment-option {
        width: 100%;
        padding-top: 20px;
        display: flex;
        justify-content: flex-start;

        .btn-save {
          width: 100px;
          height: 45px;
          background: #1890a9 0% 0% no-repeat padding-box;
          border-radius: 4px;
          color: #fff;
          outline: none;
          margin-right: 20px;
          display: flex !important;
          justify-content: center;
          align-items: center;
        }

        .btn-cancel {
          height: 45px;
          border-radius: 4px;
          color: #1890a9;
          outline: none;
        }
      }
    }
  }


}

.input-flex {
  display: flex;
}
</style>




<style lang="scss">
.invite-via-email-modal {
  width: 500px;
  margin: 0 auto;
  padding-top: 130px;

  .invite-via-email-card__body {
    padding: 20px;
    z-index: 9999;
    width: 100%;

    .__layout {
      .div {
        label {
          opacity: 0.51;
          font-family: Avenir;
          font-size: 14px;
          font-weight: normal;
          font-stretch: normal;
          font-style: normal;
          line-height: 1.2;
          letter-spacing: normal;
          color: #161615;
        }

        input {
          height: 30px;
          width: 100%;
          background: #fff;
          font-size: 14px;
          font-weight: 300;
          padding: 0 10px;
          margin: 10px 0;
          outline: none !important;
          border: none !important;
          border-radius: 5px;
          font-stretch: normal;
          line-height: 1.2;
          letter-spacing: normal;

          &:focus {
            border: none !important;
            outline: none !important;
          }

          &::placeholder {
            opacity: 0.5;
            font-style: italic;
          }
        }

        .msg {
          background: #fff;
          margin-top: 10px;
          border-radius: 5px;
          opacity: 0.68;
          padding: 10px;
          font-size: 13px;
          color: #676767;
        }
      }
    }

    .__cont {
      display: flex;
      flex-direction: column;

      .icons {
        display: flex;
        width: 100%;
        padding-bottom: 20px;
        margin-bottom: 20px;
        border-bottom: 0.7px solid #a0a0a0;
        margin-top: 10px;

        div {
          margin-right: 10px;

          label {
            font-size: 12px;
            margin-right: 10px;
          }

          input {
            margin-top: 5px;
          }
        }
      }

      .body {
        padding: 20px;
        border-radius: 5px;
        background: #f4f4f4;
        border: 1px solid #707070;

        .template {
          width: 100%;
          background: #fff;
          box-shadow: 0 6px 5px rgba(0, 0, 0, 0.16);
          margin-right: 10px;

          button {
            height: 10px;
            font-size: 4px;
            outline: none;
            color: #fff;
            border: none;
            background: #0e9695;
          }

          .header {
            display: flex;
            width: 100%;

            .first {
              display: flex;
              padding-left: 10px;
              padding-right: 10px;
              flex-direction: column;

              img {
                width: 30px;
                height: 30px;
                border-radius: 100%;
              }

              h2 {
                font-size: 6px;
                margin-top: 10px;
              }
            }

            .second {
              background: #0075a0;
              display: flex;
              flex-grow: 1;
              justify-content: center;
              align-items: center;

              .titles {
                display: flex;
                color: #fff;
                width: 100%;
                justify-content: space-between;
                padding-left: 10px;
                padding-right: 10px;

                h2 {
                  font-size: 4px;
                }

                button {
                  height: 10px;
                  font-size: 4px;
                  outline: none;
                  border: none;
                  background: #0e9695;
                }
              }
            }
          }

          .contents {
            display: flex;
            width: 100%;

            span,
            p,
            button {
              font-size: 4px !important;
            }

            .left {
              width: 100px;
            }

            .right {
              flex-grow: 1;
            }
          }
        }
      }

      .actiond {
        margin-top: 10px;
        display: flex;

        button {
          background: #1890a9;
          color: #fff;
          border-radius: 5px;
          padding: 5px 10px;
          justify-content: space-between;
          align-items: center;
        }

        .cancel {
          background: transparent;
          color: #0590ab;
        }
      }
    }

    .__input {
      margin: 20px 0;
      width: 100%;

      span {
        color: #979797;
        font-size: 14px;
        font-weight: normal;
      }

      input {
        width: 100%;
        color: gray;
        font-size: 14px;
        height: 30px;
        outline: none;
        background: #e9ebed;
        border-radius: 3px;
        padding: 2px 10px;
      }
    }

    .btns {
      display: flex;
      width: 50%;
      float: right;
      justify-content: space-between;

      .cancel {
        color: #1ba5a4;
        cursor: pointer;
        font-weight: normal;
        height: 22px;
        padding: 1px 20px;
        font-size: 14px;
      }

      .save {
        background: #1ba5a4;
        color: #fff;
        font-size: 14px;
        font-weight: normal;
        cursor: pointer;
        border-radius: 5px;
        height: 22px;
        padding: 1px 10px;
        display: flex;
        justify-content: center;
        align-items: center;

        &:disabled {
          background: #8d8d8d;
          opacity: 0.3;
        }
      }
    }

    .btns-2 {
      display: flex;
      float: right;
      margin-top: 20px;

      .save {
        width: 100px;
        height: 40px;
        font-size: 14px;
        outline: none;
        opacity: 0.97;
        border-radius: 0.6vh;
        font-family: Avenir;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.2;
        letter-spacing: normal;
        text-align: center;
        color: #fff;
        display: flex;
        justify-content: center;
        align-items: center;
        background-image: linear-gradient(to right,
            #1d9694 0%,
            #199295 36%,
            #108798 68%,
            #01759e 98%,
            #00749f 100%);
      }

      .cancel {
        width: 100px;
        height: 40px;
        font-size: 14px;
        outline: none;
        opacity: 0.51;
        font-family: Avenir;
        font-weight: 300;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.2;
        letter-spacing: normal;
        text-align: center;
        color: #161615;
      }
    }

    .__body {
      background: #f0eaea;
      padding: 20px;

      .__rowed {
        display: flex;
        width: 100%;
        margin-bottom: 20px;
        justify-content: space-between;

        span {
          color: #646262;
          font-size: 12px;
        }

        input,
        select {
          background: #ffffff;
          border-radius: 5px;
          padding: 5px 10px;
          outline: none;
          width: 80%;
          font-size: 12px;
          color: #c4c4c4;
        }

        select {
          width: 30%;
        }

        img {
          cursor: pointer;
        }

        .img {
          max-width: 15px;
          max-height: 15px;
        }
      }
    }

    .__rowed {
      position: relative;
    }
  }
}

.date-picker-aling {
  margin-top: 6px;
}
</style>